<template>
  <!-- 表单主体容器 -->
  <div class="form-container">
    <!-- 页面标题 -->
    <div class="price-report-wrapper">
      <div class="price-report-card">
        <!-- 顶部操作栏 -->
        <!-- 顶部操作栏 -->
        <div class="operation-header">
          <div class="header-left">
            <el-button
              type="text"
              icon="el-icon-arrow-left"
              @click="goBack"
              class="back-btn"
            >
              返回
            </el-button>
            <h2 class="title">
              <i class="el-icon-notebook-2"></i>
              补贴申报记录
            </h2>
          </div>
          <div class="action-buttons">
            <el-button
              type="primary"
              @click="createPerformance"
              class="action-btn primary-btn"
            >
              补贴申报
            </el-button>
          </div>
        </div>

        <!-- 数据表格区域 -->
        <div class="table-container">
          <el-table
            ref="recordsTable"
            :data="reportRecords"
            highlight-current-row
            style="width: 100%"
            :header-cell-style="{
              background: '#f8fafc',
              color: '#606266',
              fontWeight: '600',
            }"
            :cell-style="{ padding: '16px 0' }"
            empty-text="暂无上报记录"
            class="elegant-table"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="companyName"
              label="企业全称"
              width="200"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="creditCode"
              label="统一社会信用代码"
              width="200"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="subsidyType"
              label="申报补贴类型"
              width="200"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="applyAmount"
              label="申报金额(万元)"
              width="140"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="projectDesc"
              label="项目/业绩简述"
              width="300"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="auditStatus"
              label="审核状态"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                {{
                  scope.row.auditStatus === 0
                    ? '待审核'
                    : scope.row.auditStatus === 1
                      ? '通过'
                      : '驳回'
                }}
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(scope)"
                  class="detail-btn"
                >
                  <i class="el-icon-document"></i> 查看
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog
      title="补贴申报"
      :visible.sync="showDialog"
      width="800px"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <div class="performance-upload-page">
        <!-- 绩效表单 -->
        <el-form
          ref="subsidyFormRef"
          :model="subsidyForm"
          :rules="formRules"
          label-width="150px"
          class="apply-form"
        >
          <!-- 移除 disabled 属性，新增必填校验 -->
          <el-form-item label="企业全称" prop="companyName">
            <el-input
              v-model="subsidyForm.companyName"
              placeholder="请输入企业全称"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item>

          <!-- 移除 disabled 属性，新增必填校验 -->
          <el-form-item label="统一社会信用代码" prop="creditCode">
            <el-input
              v-model="subsidyForm.creditCode"
              placeholder="请输入统一社会信用代码"
              show-word-limit
              maxlength="30"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item>

          <!-- 移除 disabled 属性，新增必填校验 -->
          <el-form-item label="申报补贴类型" prop="subsidyType">
            <el-select
              v-model="subsidyForm.subsidyType"
              placeholder="请选择补贴类型"
              style="width: 100%"
              :disabled="isDisabled"
            >
              <el-option
                label="高新技术企业补贴"
                value="高新技术企业补贴"
              ></el-option>
              <el-option label="小微企业补贴" value="小微企业补贴"></el-option>
              <el-option label="研发补贴" value="研发补贴"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="申报金额(万元)" prop="applyAmount">
            <el-input
              v-model.number="subsidyForm.applyAmount"
              placeholder="请输入申报金额"
              type="number"
              min="0"
              step="0.01"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item>

          <el-form-item label="项目/业绩简述" prop="projectDesc">
            <el-input
              v-model="subsidyForm.projectDesc"
              type="textarea"
              :rows="4"
              show-word-limit
              maxlength="500"
              placeholder="请简述项目/业绩情况"
              :disabled="isDisabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="驳回原因"
            prop="auditRemark"
            v-show="isDisabled && subsidyForm.auditStatus == 2"
          >
            <el-input
              v-model="subsidyForm.auditRemark"
              type="textarea"
              :rows="3"
              placeholder="请输入驳回原因（必填）"
              maxlength="500"
              show-word-limit
              :disabled="isDisabled"
            />
          </el-form-item>
        </el-form>
      </div>

      <!-- 电子申请材料上传区域 -->
      <div class="form-section">
        <h2 class="section-title">电子申请材料上传</h2>
        <div class="upload-section">
          <div class="upload-tip">
            <span
              class="required-tag"
              style="display: inline-block; padding: 20px 0"
              >必备材料清单</span
            >
          </div>

          <!-- 文件上传组件 -->
          <el-upload
            ref="uploadRef"
            class="uploader"
            action="#"
            :file-list="fileList"
            :accept="acceptTypes"
            :limit="10"
            :on-exceed="handleExceed"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :before-upload="beforeUpload"
            :http-request="customUpload"
            :on-remove="handleRemove"
            drag
            :disabled="isDisabled"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              点击或拖拽上传文件（营业执照、审计报告、研发证明等）
            </div>
            <div class="el-upload__tip" slot="tip">
              <span class="support-format"
                >支持格式：PDF、DOC、JPG、PNG，单个文件不超过20MB，可多选。</span
              >
            </div>
          </el-upload>
        </div>
      </div>
      <!-- 提交按钮 -->
      <div
        class="submit-section"
        style="margin-top: 30px; text-align: center"
        v-show="!isDisabled"
      >
        <el-button
          type="primary"
          size="large"
          class="submit-btn"
          @click="handleSubmit"
        >
          <i class="el-icon-check-circle"></i> 提交补贴申请（无纸化递交）
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { createSubsidy, getSubsidy } from '@/API/apply/apply.js';
export default {
  name: 'SubsidyApplication',
  data() {
    return {
      // 表单数据（保留初始值，可编辑）
      subsidyForm: {
        companyName: '',
        creditCode: '',
        subsidyType: '',
        applyAmount: '',
        projectDesc: '',
        attachmentUrl: '',
        auditRemark: '',
      },
      showDialog: false,
      reportRecords: [],
      isDisabled: false,
      // 表单校验规则（新增企业全称、信用代码、补贴类型的必填校验）
      formRules: {
        companyName: [
          { required: true, message: '请输入企业全称', trigger: 'blur' },
          {
            min: 2,
            max: 100,
            message: '企业全称长度需在2-100字之间',
            trigger: 'blur',
          },
        ],
        creditCode: [
          {
            required: true,
            message: '请输入统一社会信用代码',
            trigger: 'blur',
          },
          {
            pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/,
            message: '请输入正确的统一社会信用代码',
            trigger: 'blur',
          },
        ],
        subsidyType: [
          { required: true, message: '请选择申报补贴类型', trigger: 'change' },
        ],
        applyAmount: [
          { required: true, message: '请输入申报金额', trigger: 'blur' },
          {
            type: 'number',
            min: 0,
            message: '申报金额不能为负数',
            trigger: 'blur',
          },
        ],
        projectDesc: [
          { required: true, message: '请填写项目/业绩简述', trigger: 'blur' },
          {
            min: 10,
            max: 500,
            message: '简述长度需在10-500字之间',
            trigger: 'blur',
          },
        ],
      },
      fileList: [],
      acceptTypes: '.pdf,.doc,.docx,.jpg,.jpeg,.png', // 支持的文件类型
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/');
      }
    },
    getData() {
      getSubsidy().then((res) => {
        if (res.code === 200) {
          this.reportRecords = res.data.records;
        }
      });
    },
    handleDialogClose() {
      this.$refs.subsidyFormRef.resetFields();
      this.fileList = [];
    },
    createPerformance() {
      this.showDialog = true;
      this.isDisabled = false;
      this.subsidyForm = {
        companyName: '',
        creditCode: '',
        subsidyType: '',
        applyAmount: '',
        projectDesc: '',
        attachmentUrl: '',
        auditStatus: 0,
      };
      this.fileList = [];
      this.$nextTick(() => {
        this.$refs.subsidyFormRef.clearValidate();
      });
    },
    handleClick(scope) {
      this.showDialog = true;
      this.subsidyForm = scope.row;
      this.isDisabled = true;
      this.fileList = [];
      this.fileList = JSON.parse(this.subsidyForm.attachmentUrl);
    },
    // 提交表单
    handleSubmit() {
      this.subsidyForm.attachmentUrl = JSON.stringify(this.fileList);
      this.$refs.subsidyFormRef.validate((valid) => {
        if (valid) {
          // 校验通过，调用提交接口
          this.$confirm('确认提交补贴申请？提交后不可修改', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              createSubsidy(this.subsidyForm).then((res) => {
                if (res.code === 200) {
                  this.$message.success('补贴申请提交成功！');
                  this.showDialog = false;
                  this.getData();
                }
              });
            })
            .catch(() => {
              this.$message.info('已取消提交');
            });
        } else {
          this.$message.error('请完善必填项后提交');
          return false;
        }
      });
    },
    // 文件上传前校验
    beforeUpload(file) {
      // 校验文件大小（20MB）
      const isOverSize = file.size / 1024 / 1024 > 20;
      if (isOverSize) {
        this.$message.error(`文件 ${file.name} 大小超过20MB，请压缩后上传`);
        return false;
      }
      return true;
    },

    // 文件超出数量限制
    handleExceed(files, fileList) {
      this.$message.warning(
        `最多只能上传10个文件，本次选择了${files.length}个，已超出限制`,
      );
    },

    // 文件上传成功
    handleUploadSuccess(response, file, fileList) {
      this.$message.success(`文件 ${file.name} 上传成功`);
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      // 如果删除后清空了所有文件，清空附件URL
      if (fileList.length === 0) {
        this.subsidyForm.attachmentUrl = '';
      }
    },

    // 文件上传失败
    handleUploadError(err, file, fileList) {
      this.$message.error(`文件 ${file.name} 上传失败，请重试`);
    },
    customUpload({ file, onSuccess, onError }) {
      const formData = new FormData();
      formData.append('file', file);

      fetch('/apisix/resource/api/upload', {
        method: 'POST',
        headers: {
          Authorization:
            'Bearer ' + (localStorage.getItem('ordinaryToken') || ''),
        },
        body: formData,
      })
        .then((res) => res.json())
        .then((res) => {
          this.$message.success('文件上传成功');
          onSuccess(res);
        })
        .catch((err) => {
          this.$message.error('文件上传失败');
          onError(err);
        });
    },
  },
};
</script>

<style scoped lang="less">
.subsidy-application-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background: #f8f9fa;
  min-height: 100vh;

  // 页面头部
  .page-header {
    margin-bottom: 30px;
    h1 {
      font-size: 24px;
      color: #333;
      margin: 0 0 10px 0;
      font-weight: 600;
    }
    .progress-bar {
      font-size: 14px;
      color: #666;
    }
  }

  // 表单主体
  .application-form {
    background: #fff;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

    // 表单分区
    .form-section {
      margin-bottom: 40px;
      .section-title {
        font-size: 18px;
        color: #333;
        margin: 0 0 20px 0;
        font-weight: 600;
        padding-bottom: 10px;
        border-bottom: 1px solid #eee;
      }
    }

    // 基础表单样式
    .info-form {
      .el-form-item {
        margin-bottom: 20px;
      }
      .el-input,
      .el-select,
      .el-textarea {
        width: 600px;
      }
    }

    // 文件上传区域
    .upload-section {
      .upload-tip {
        margin-bottom: 15px;
        .required-tag {
          color: #e6a23c;
          font-weight: 500;
        }
      }
      .uploader {
        width: 100%;
        .el-upload {
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          transition: var(--el-transition-duration-fast);
          padding: 20px;
          text-align: center;
        }
        .el-upload:hover {
          border-color: var(--el-color-primary);
        }
        .support-format {
          color: #999;
          font-size: 12px;
        }
      }
    }

    // 提交按钮区域
    .submit-section {
      margin-top: 30px;
      text-align: center;
      .submit-btn {
        width: 300px;
        height: 48px;
        font-size: 16px;
        background: #1989fa;
        border: none;
        border-radius: 4px;
        &:hover {
          background: #0c6ede;
        }
      }
    }
  }
}

// 适配移动端
@media (max-width: 768px) {
  .subsidy-application-page {
    padding: 10px;
    .application-form {
      padding: 15px;
      .info-form {
        .el-input,
        .el-select,
        .el-textarea {
          width: 100%;
        }
      }
      .submit-section .submit-btn {
        width: 100%;
      }
    }
  }
}

// 移动端适配
@media (max-width: 768px) {
  .performance-upload-page {
    padding: 15px;

    .form-container {
      padding: 15px;

      .form-header {
        h2 {
          font-size: 16px;
        }
      }

      .performance-form {
        .el-form-item {
          label-width: 80px !important;
        }
      }
    }
  }
}
.price-report-wrapper {
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 60px);
  padding: 24px;
  background-color: #f5f7fa;

  .price-report-card {
    width: 100%;
    max-width: 1200px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    padding: 24px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    }
  }

  // ... existing code ...
  .operation-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid #f0f2f5;

    .header-left {
      display: flex;
      align-items: center;
      gap: 16px;

      .back-btn {
        font-size: 14px;
        color: #606266;
        padding: 8px 12px;
        border-radius: 4px;
        transition: all 0.3s;

        &:hover {
          color: #409eff;
          background: rgba(64, 158, 255, 0.1);
        }

        i {
          margin-right: 4px;
          font-size: 16px;
        }
      }
    }

    .title {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
      color: #303133;
      display: flex;
      align-items: center;

      i {
        margin-right: 10px;
        color: #409eff;
        font-size: 24px;
      }
    }

    .action-buttons {
      display: flex;
      gap: 12px;

      .action-btn {
        padding: 10px 16px;
        border-radius: 6px;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
        }
      }

      .primary-btn {
        background: linear-gradient(135deg, #409eff, #66b1ff);
        border: none;
      }
    }
  }
  // ... existing code ...

  .table-container {
    margin: 0 auto;
    overflow: hidden;
    border-radius: 6px;
    border: 1px solid #ebeef5;

    .elegant-table {
      ::v-deep .el-table__header-wrapper {
        th {
          font-weight: 600;
          letter-spacing: 0.5px;
        }
      }

      ::v-deep .el-table__body-wrapper {
        .el-table__row {
          transition: background-color 0.3s;

          &:hover {
            background-color: #f8fafc;
          }

          .cell {
            .company-name {
              font-weight: 500;
              color: #303133;
            }
          }
        }
      }

      .detail-btn {
        color: #409eff;
        padding: 8px 12px;
        border-radius: 4px;
        transition: all 0.3s;

        i {
          margin-right: 6px;
        }

        &:hover {
          background: rgba(64, 158, 255, 0.1);
          color: #66b1ff;
        }
      }

      ::v-deep .el-table__empty-block {
        min-height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;

        .el-table__empty-text {
          color: #909399;
          font-size: 16px;
        }
      }
    }
  }
}

@media (max-width: 992px) {
  .price-report-wrapper {
    padding: 16px;

    .price-report-card {
      padding: 16px;
    }

    .operation-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;

      .action-buttons {
        width: 100%;
        flex-wrap: wrap;
      }
    }

    .table-container {
      overflow-x: auto;
    }
  }
}
</style>
